import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import * as pbi from 'powerbi-client';
import * as models from 'powerbi-models';
import {isMobile} from 'react-device-detect';
// import qs from 'query-string';

class DashboardView extends Component {
    componentDidMount() {
        var that = this;

        const gid = this.props.match.params.gid;
        const did = this.props.match.params.did;

        const uri = config.getUriPath('dashboards/embedToken?id=' + did + '&group_id=' + gid)

        const mobileLayout = models.LayoutType.MobilePortrait;
        const desktopLayout = models.LayoutType.Custom;
        var thisLayout = desktopLayout;
        if (isMobile) {
            thisLayout = mobileLayout;
        }
        var v_viewMode = models.ViewMode.View;
        var v_Permissions = models.Permissions.All;

        console.log('uri: ' + uri);

        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
                console.log(response);
                throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }
  
            //console.log(response)
            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }

            const embedUrl = "https://app.powerbi.com/dashboardEmbed?dashboardId=" + did + "&groupId=" + gid;

            /*
            var pbiconfig = {
                type: 'dashboard',
                tokenType: 1,
                accessToken: data.token,
                embedUrl: embedUrl,
                id: did,
                permissions: 7,
                settings: {
                  filterPaneEnabled: true,
                  navContentPaneEnabled: true
                  }
                };
             */

                var pbiconfig = {
                    type: 'dashboard',
                    tokenType: 1,
                    accessToken: data.token,
                    embedUrl: embedUrl,
                    id: did,
                    permissions: v_Permissions,
                    viewMode: v_viewMode,
                    settings: {
                      filterPaneEnabled: true,
                      navContentPaneEnabled: true,
                      //background: 1,                  
                      layoutType: thisLayout
                      }
                    };
                
                let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
                var reportContainer = document.getElementById('rptContainer');
                //console.log(reportContainer)
                
                var container = powerbi.embed(reportContainer, pbiconfig);    
                container.on("tileClicked", function (event) {
                    //console.log(event);
                    if (event.detail.reportEmbedUrl) {
                        var vars = [], hash;
                        var hashes = event.detail.reportEmbedUrl.slice(event.detail.reportEmbedUrl.indexOf('?') + 1).split('&');

                        for(var i = 0; i < hashes.length; i++)
                        {
                          hash = hashes[i].split('=');
                          vars.push(hash[0]);
                          vars[hash[0]] = hash[1];
                        }

                        var rid = vars["reportId"];
                        var gid=vars["groupId"];

                        that.props.history.push("/visualizations/view/" + rid + "/" + gid + "?n=");
                    }
                });
          });
    }

    render() {
        // const title = qs.parse(this.props.location.search).n;

        return <div>
                    <div className="center-div">
                        {/* <h1>{title}</h1> */}
                    </div>
                    <div className="center-div">
                        <div className="rptContainer" id="rptContainer"></div>
                    </div>
                </div>
    }
}

export default DashboardView


// WEBPACK FOOTER //
// ./src/Components/Dashboards/DashboardView.js